@if (layout === 'empty') {
    <!-- ----------------------------------------------------------------------------------------------------- -->
    <!-- Empty layout (sign-in, etc.) -->
    <!-- ----------------------------------------------------------------------------------------------------- -->
    <empty-layout></empty-layout>
} @else {
    <!-- ----------------------------------------------------------------------------------------------------- -->
    <!-- Main layout - Shows mobile or desktop depending on screen size -->
    <!-- ----------------------------------------------------------------------------------------------------- -->
    @if (isMobile) {
        <!-- Mobile layout (< 768px) -->
        <mobile-layout class=flex-col></mobile-layout>
    } @else {
        <!-- Desktop layout (>= 768px) -->
        <desktop-layout></desktop-layout>
    }
}
